export const REQUEST_CURRENT_ROUTE = 'REQUEST_CURRENT_ROUTE';
export const CURRENT_ROUTE = 'CURRENT_ROUTE';
export const CREATE_ROUTE = 'CREATE_ROUTE';
export const CLOSE_ROUTE = 'CLOSE_ROUTE';
export const ROUTE_ERROR = 'ROUTE_ERROR';
